import React from "react";

export default ({children}) => (
  <div className="container-fluid">
    <div className="row justify-content-center">
      <div className="col col-lg-5 col-md-8 col-sm-10 mt-5">{children}</div>
    </div>
  </div>
);
